<template>
  <div v-if="config.FuzzyMatchConfig">
    <hr>
    <div class="upper-fuzzy__container">
      <validation-provider
        v-slot="{errors, dirty, touched, valid}"
        rules="required"
        name="Calculation order"
      >
        <b-form-group label="Calculation order">
          <b-form-input
            id="calculation-order"
            v-model="config.OrderOfCalculation"
            type="number"
            :state="(!dirty && !touched) ? null : valid ? null : false"
          />
          <input-error-message :error="errors" />
        </b-form-group>
      </validation-provider>

      <validation-provider
        v-slot="{errors, dirty, valid}"
        rules="numeric|required|min_value:1"
        name="Include top X matches"
      >
        <b-form-group label="Include top X matches">
          <b-form-input
            id="top-x-suggestions"
            v-model="config.FuzzyMatchConfig.TopXSuggestions"
            type="number"
            :state="!dirty ? null : valid ? null : false"
          />
          <input-error-message :error="errors" />
        </b-form-group>
      </validation-provider>
    </div>
    <div class="checkboxes__wrapper">
      <div class="inline__label">
        <b-form-checkbox
          id="autoMatch"
          v-model="autoMatchDefault"
          @change="onAutoMatchChange"
        />
        <label for="autoMatch">Auto match</label>
      </div>
      <div class="inline__label">
        <b-form-checkbox
          id="recalculateWhenSourceDataChanged"
          v-model="config.FuzzyMatchConfig.RecalculateWhenSourceDataChanges"
        />
        <label for="recalculateWhenSourceDataChanged">
          Recalculate when source data changed
        </label>
      </div>
    </div>
    <div class="upper-fuzzy__container">
      <validation-provider
        v-slot="{errors, dirty,touched, valid}"
        rules="numeric|required|min_value:1|max_value:100"
        name="Auto match threshold"
      >
        <b-form-group label="Auto match threshold">
          <b-input-group append="%">
            <b-form-input
              id="auto-match-threshold"
              v-model="config.FuzzyMatchConfig.AutoMatchThreshold"
              :disabled="!autoMatchDefault"
              :state="(!dirty && !touched) ? null : valid ? null : false"
            />
          </b-input-group>
          <input-error-message :error="errors" />
        </b-form-group>
      </validation-provider>
      <validation-provider
        v-slot="{errors, dirty,touched, valid}"
        rules="numeric|required|min_value:1|max_value:100"
        name="Only include matches over X percentage"
      >
        <b-form-group label="Only include matches over X percentage">
          <b-input-group append="%">
            <b-form-input
              id="match-threshold"
              v-model="config.FuzzyMatchConfig.MatchThreshold"
              :state="(!dirty && !touched) ? null : valid ? null : false"
            />
          </b-input-group>
          <input-error-message :error="errors" />
        </b-form-group>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import InputErrorMessage from '@/modules/DataManagement/components/InputErrorMessage.vue';
import {createNamespacedHelpers} from 'vuex';

const {
  mapState: dataManagementMapState,
} = createNamespacedHelpers('dataManagement');
export default {
  name: 'UpperFuzziMatching',
  components: {InputErrorMessage},
  data() {
    return {
      autoMatchDefault: false,
    };
  },
  watch: {
    'config.FuzzyMatchConfig.AutoMatchThreshold'(val) {
      this.autoMatchDefault = !!val;
    },
  },
  computed: {
    ...dataManagementMapState({
      config: state => state.builder.tableFieldModal.data.dataTypeJSON,
    }),
  },
  methods: {
    onAutoMatchChange(e) {
      if (!e) {
        this.config.FuzzyMatchConfig.AutoMatchThreshold = null;
      } else {
        this.config.FuzzyMatchConfig.AutoMatchThreshold = 100;
      }
    },
  },
  mounted() {
    this.autoMatchDefault = !!this.config.FuzzyMatchConfig.AutoMatchThreshold;
  },
};
</script>

<style scoped>
.checkboxes__wrapper {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.upper-fuzzy__container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 10px;
}

.inline__label {
  display: flex;
  align-items: center;

  label {
    margin-bottom: 0;
  }
}
</style>
